import React, { useMemo } from 'react';

import ConfigureSurveyAssessment from 'js/engines/SurveyAssessment/components/ConfigureSurveyAssessment';
import { assessmentPayloadFromTemplate } from 'js/utils/workspace-template';

/**
 * The configure step for a live template, so the host can preview its
 * questions and drop any before launching. A published workspace template
 * arrives as an editor document, so it is flattened into question sets
 * first; built-in ones already have them.
 */
export default function ConfigureLiveAssessment({ template, ...props }) {
  const normalizedTemplate = useMemo(
    () => ({
      ...template,
      assessment: assessmentPayloadFromTemplate(template),
    }),
    [template]
  );

  return <ConfigureSurveyAssessment template={normalizedTemplate} {...props} />;
}
